import { useCurrentAppLayoutId } from '@src/hooks/useAppLayoutId';
import type { LedgerAccountTypeEnum } from '@talos/kyoko';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccountLedgerEventsDetailsRoute } from '../../../Routes/routes';

/**
 * A hook returning a function to be called when you wish to navigate to the Account Ledger Events "page".
 */
export function useNavigateToAccountLedgerEvents() {
  const navigate = useNavigate();
  const layoutId = useCurrentAppLayoutId();

  return useCallback(
    ({ account, asset, accountType }: { account: string; asset?: string; accountType: LedgerAccountTypeEnum }) => {
      navigate(getAccountLedgerEventsDetailsRoute({ asset, account, accountType, layoutId }));
    },
    [navigate, layoutId]
  );
}
